/***      Tabs         ***/
<template>
  <div class="navTabs">
    <div class="Content">
      <ul class="clear" :style="[ulWidth]">
        <li class="navTabsLi"
            v-for="(item,index) in data && data.length > 0 ? data : null"
            ref="navTabsLi"
            @click="actionFn(item)"
            :class="pathFn===item.url?'navTabsLiAc':''"
            :style="[liWidth]">
          <span class="val">{{item.name}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Toucth from '../../../../assets/js/method'

  export default {
    components: {},
    props: ['data'],
    name: 'xk-navTabs',
    computed: {
      ...mapGetters({}),
      pathFn: function () {
        return this.$route.fullPath
      }
    },
    data () {
      return {
        ulWidth: {
          width: '100%'
        },
        liWidth: {
          width: 'auto'
        }
      }
    },
    watch: {},
    methods: {
      actionFn: function (obj) {
        this.$emit('click', {data: obj})
      },
      styleFn: function () {
        let that = this
        let Num = 0
        if (that.$props.data.length > 0) {
          Num = that.$props.data.length
        }
        if (Num > 0 && Num > 4) {
          that.liWidth = {
            width: 'auto'
          }
          let ulWidth = 0
          let navTabsLiA = that.$refs.navTabsLi
          for (let i = 0; i < navTabsLiA.length; i++) {
            let liW = Number(Toucth.gainStyle(navTabsLiA[i], 'width', 'px'))
            ulWidth += liW
          }
          that.ulWidth = {
            width: (ulWidth + 1) + 'px'
          }
        }
        if (Num > 0 && Num <= 4) {
          that.ulWidth = {
            width: '100%'
          }
          that.liWidth = {
            width: (100 / Num).toFixed(6) + '%'
          }
        }
      }
    },
    mounted: function () {
      this.styleFn()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .navTabs {
    width: 100%;
    height: inherit;
    background: #fff;
    .Content {
      width: 100%;
      overflow-x: scroll;
      height: inherit;
      ul {
        min-width: 100%;
        height: inherit;
        li {
          position: relative;
          height: inherit;
          float: left;
          text-align: center;
          .val {
            display: inline-block;
            text-align: center;
            padding: 0 1rem;
          }
        }
        li:after {
          content: '';
          width: 1px;
          background: #eee;
          height: 50%;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translate(0, -50%);
        }
        li:nth-last-child(1):after {
          content: '';
          display: none;
        }
        .navTabsLiAc {
          color: #f06553;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// navTabs.vue?09999dab